<template>
    <transition name="fade">
        <main>
            <div v-if="user.mobile_number">
                <div class="row">
                    <div class="col-md-4 col-sm-6">
                        <div class="form-group">
                            <label>First Name</label><span class="text-danger">*</span>
                            <input class="form-control form-control-sm text-uppercase" disabled :value="user.firstname" />
                        </div>
                    </div>
                    <div class="col-md-3 col-sm-6">
                        <div class="form-group">
                            <label>Middle Name</label><span class="text-danger">*</span>
                            <input class="form-control form-control-sm text-uppercase" disabled :value="user.middlename" />
                        </div>
                    </div>
                    <div class="col-md-3 col-sm-6">
                        <div class="form-group">
                            <label>Last Name</label><span class="text-danger">*</span>
                            <input class="form-control form-control-sm text-uppercase" disabled :value="user.lastname" />
                        </div>
                    </div>
                    <div class="col-md-2 col-sm-6">
                        <div class="form-group">
                            <label>Suffix</label><span class="text-danger">*</span>
                            <select class="form-control custom-select-sm" disabled v-model="user.suffix_code">
                                <option :value="null" disabled></option>
                                <option v-for="(item,index) in suffixes" :key="index" :value="item.suffix_code">{{item.suffix_desc}}</option>
                            </select>
                        </div>
                    </div>
                </div>

                <div class="row">
                    <div class="col-md-2 col-sm-6">
                        <div class="form-group">
                            <label>Birth Date</label><span class="text-danger">*</span>
                            <input class="form-control form-control-sm text-uppercase" disabled :value="user.birthdate | MM/DD/YYYY " />
                        </div>
                    </div>
                    <div class="col-md-2 col-sm-6">
                        <div class="form-group">
                            <label>Sex</label><span class="text-danger">*</span>
                            <select class="form-control custom-select-sm" v-model="form.gender_id" :class="{'is-invalid': $v.form.gender_id.$error}">
                                <option selected disabled :value='null'>- Select -</option>
                                <option v-for="(item,index) in gender" :key="index" :value="item.gender_id">{{item.gender_desc}}</option>
                            </select>
                        </div>
                    </div>
                    <div class="col-md-4 col-sm-6">
                        <div class="form-group">
                            <label>Mobile No.</label><span class="text-danger">*</span>
                            <input class="form-control form-control-sm text-uppercase" disabled v-model="form.mobile" v-input-mask data-inputmask-mask="(9999) 9999999" data-inputmask-placeholder="" />
                            <em class="fs-13">Ex. (0912) 3456789</em>
                        </div>
                    </div>
                    <div class="col-md-4 col-sm-6">
                        <div class="form-group">
                            <label>Landline No.</label>
                            <input class="form-control form-control-sm text-uppercase" v-model="form.landline" v-input-mask data-inputmask-mask="(999) 999999" data-inputmask-placeholder="" />
                            <em class="fs-13">Ex. (000) 000000</em>
                        </div>
                    </div>
                </div>

                <hr />
                <label>Place of Birth</label>
                <div class="row">
                    <div class="col-sm-4">
                        <div class="form-group">
                            <label>Country</label><span class="text-danger">*</span>
                            <v-select label="country_name" :options="country" :reduce="country => country.country_iso" :class="{'vs-invalid': $v.form.country_iso.$error}"
                                :clearable="false" placeholder="- Select -" v-model="form.country_iso" @input="selectedCountry(form.country_iso)" />
                        </div>
                    </div>
                    <div class="col-sm-4" v-if="form.country_iso == 'PH'">
                        <div class="form-group">
                            <label>Province</label><span class="text-danger">*</span>
                            <v-select label="province" :options="provinces" :reduce="province => province.province_code" :class="{'vs-invalid': $v.form.province_code.$error}"
                                :clearable="false" placeholder="- Select -" v-model="form.province_code" @input="getCity(form.province_code), form.city_code=null" />
                        </div>
                    </div>
                    <div class="col-sm-4" v-if="form.country_iso == 'PH'">
                        <div class="form-group">
                            <label>City/Municipality</label><span class="text-danger">*</span>
                            <v-select label="city" :options="cities" :reduce="city => city.city_code" :class="{'vs-invalid': $v.form.city_code.$error}"
                                :clearable="false" v-model="form.city_code" placeholder="- Select -" />
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-3 col-sm-6">
                        <div class="form-group">
                            <label>Civil Status</label><span class="text-danger">*</span>
                            <v-select label="cs_desc" :options="civil_status" :reduce="cs_desc => cs_desc.cs_code" :class="{'vs-invalid': $v.form.cs_code.$error}"
                                :clearable="false" v-model="form.cs_code" placeholder="- Select -" @input="selectedCS(form.cs_code)" />
                        </div>
                    </div>
                    <div class="col-md-3 col-sm-6">
                        <div class="form-group">
                            <label>Citizenship</label><span class="text-danger">*</span>
                            <select class="form-control custom-select-sm">
                                <option selected value="Filipino">Filipino</option>
                            </select>
                        </div>
                    </div>
                    <div class="col-md-3 col-sm-6">
                        <div class="form-group">
                            <label>No. of Children</label><span class="text-danger">*</span>
                            <input type="number" class="form-control form-control-sm text-uppercase" v-model="form.number_child" :class="{'is-invalid': $v.form.number_child.$error}" />
                        </div>
                    </div>
                    <div class="col-md-3 col-sm-6">
                        <div class="form-group">
                            <label>Household Size</label><span class="text-danger">*</span>
                            <input type="number" class="form-control form-control-sm text-uppercase" v-model="form.number_fam" :class="{'is-invalid': $v.form.number_fam.$error}" />
                        </div>
                    </div>
                </div>
                <div>
                    <hr />
                    <label>Mother's Maiden Name</label>
                    <div class="row">
                        <div class="col-md-4 col-sm-6">
                            <div class="form-group">
                                <label>First Name</label><span class="text-danger">*</span>
                                <input class="form-control form-control-sm text-uppercase" v-model="mother.fname" :class="{'is-invalid': $v.mother.fname.$error}" />
                            </div>
                        </div>
                        <div class="col-md-3 col-sm-6">

                            <div class="form-group mb-0">
                                <label>Middle Name</label><span class="text-danger">*</span>
                                <input class="form-control form-control-sm text-uppercase" v-model="mother.mname" :disabled="cb1"
                                    :class="{ 'is-invalid': $v.mother.mname.$error }" />
                            </div>
                            <div class="form-group">
                                <div class="custom-control custom-checkbox">
                                    <input id="cb1" class="custom-control-input" type="checkbox" v-model="cb1" @change="mother.mname=''" />
                                    <label for="cb1" class="custom-control-label">Click here if no middle name</label>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-3 col-sm-6">
                            <div class="form-group">
                                <label>Last Name</label><span class="text-danger">*</span>
                                <input class="form-control form-control-sm text-uppercase" v-model="mother.lname" :class="{'is-invalid': $v.mother.lname.$error}" />
                            </div>
                        </div>
                        <div class="col-md-2 col-sm-6">
                            <div class="form-group">
                                <label>Suffix</label>
                                <select class="form-control custom-select-sm" v-model="mother.suffix_code">
                                    <option :value='null'>- Select -</option>
                                    <option v-for="(item,index) in suffixes" :key="index" :value="item.suffix_code">{{item.suffix_desc}}</option>
                                </select>
                            </div>
                        </div>
                    </div>
                </div>
                <div v-if="form.cs_code=='CS002'">
                    <hr />
                    <label>Name of Spouse</label>
                    <div class="row">
                        <div class="col-md-4 col-sm-6">
                            <div class="form-group">
                                <label>First Name</label><span class="text-danger">*</span>
                                <input class="form-control form-control-sm text-uppercase" v-model="spouse.fname" :class="{'is-invalid': $v.spouse.fname.$error}" />
                            </div>
                        </div>
                        <div class="col-md-3 col-sm-6">
                            <div class="form-group mb-0">
                                <label>Middle Name</label><span class="text-danger">*</span>
                                <input class="form-control form-control-sm text-uppercase" v-model="spouse.mname" :disabled="cb2"
                                    :class="{ 'is-invalid': $v.spouse.mname.$error }" />
                            </div>
                            <div class="form-group">
                                <div class="custom-control custom-checkbox">
                                    <input id="cb2" class="custom-control-input" type="checkbox" v-model="cb2" @change="spouse.mname=''" />
                                    <label for="cb2" class="custom-control-label">Click here if no middle name</label>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-3 col-sm-6">
                            <div class="form-group">
                                <label>Last Name</label><span class="text-danger">*</span>
                                <input class="form-control form-control-sm text-uppercase" v-model="spouse.lname" :class="{'is-invalid': $v.spouse.lname.$error}" />
                            </div>
                        </div>
                        <div class="col-md-2 col-sm-6">
                            <div class="form-group">
                                <label>Suffix</label>
                                <select class="form-control custom-select-sm" v-model="spouse.suffix_code">
                                    <option :value='null'>- Select -</option>
                                    <option v-for="(item,index) in suffixes" :key="index" :value="item.suffix_code">{{item.suffix_desc}}</option>
                                </select>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-3 col-sm-6">
                            <div class="form-group">
                                <label>Birth Date of Spouse</label><span class="text-danger">*</span>
                                <input-calendar v-model="spouse.date_birth" class="form-control form-control-sm" :class="{'is-invalid': $v.spouse.date_birth.$error}"
                                    id="spouse-bdate" v-input-mask data-inputmask-alias="datetime" data-inputmask-inputformat="mm/dd/yyyy" />
                            </div>
                        </div>
                    </div>
                </div>
                <hr />
                <div class="row">
                    <div class="col-12">
                        <button class="btn btn-primary float-right" @click="btnNext()">Next<i class="fas fa-arrow-right ml-1"></i></button>
                    </div>
                </div>
            </div>

            <div class="modal fade" id="modalMobile" tabindex="-1" role="dialog" data-backdrop="static" data-keyboard="false">>
                <div class="modal-dialog modal-dialog-centered" role="document">
                    <div class="modal-content">
                        <div class="modal-header">
                            <h5 class="modal-title bold">Add Mobile Number</h5>
                        </div>
                        <div class="modal-body">
                            <div class="alert alert-info2 text-justify">
                                <i class="fas fa-info-circle mr-1 fs-15"></i>Our system has detected that you have not entered your mobile number or the mobile number entered during your initial registration is invalid. Please add a valid mobile number to proceed.
                            </div>
                            <div class="alert alert-danger2 alert-dismissible mb-2" role="alert" v-if="error">
                                <button type="button" class="close mt-n1" data-dismiss="alert" @click="error=0">&times;</button>
                                <a target="#err0" hidden id="err"></a>
                                <div class="alert-body">
                                    <p v-if="error_message && errors.length == 0" class="mb-0">
                                        {{ error_message }}
                                    </p>
                                    <div v-for="(v, k) in errors" :key="k">
                                        <p class="mb-0" v-for="item in v" :key="item">{{ item }}</p>
                                    </div>
                                </div>
                            </div>
                            <div class="form-group">
                                <label>Mobile Number</label>
                                <input class="form-control form-control-sm" @paste="pasteMobile" ref="mob" :class="{ 'is-invalid': $v.mobile_number.$error }" type="text" autocomplete="off" v-model="mobile_number" v-input-mask data-inputmask-mask="(9999) 9999999" data-inputmask-placeholder="">
                                <p class="fs-13 danger m-0 p-0" v-if="mobile_number && $v.mobile_number.$error">Not a valid Mobile Number</p>
                            </div>
                        </div>
                        <div class="modal-footer">
                            <button class="btn btn-primary" @click="submitMobile">Submit</button>
                        </div>
                    </div>
                </div>
            </div>
        </main>
    </transition>
</template>
<script>
    import moment from "moment";
    import country from "@json/country.json";
    import {
        required,
        requiredIf,
        minLength
    } from "vuelidate/lib/validators";
    export default {
        data() {
            return {
                mobile_number: '',
                error: false,
                errors: [],
                error_message: '',

                form: {
                    borrower_id: null,
                    gender_id: null,
                    cs_code: null,
                    province_code: null,
                    city_code: null,
                    number_child: null,
                    number_fam: null,
                    user_id: null,
                    country_iso: 'PH',
                    mobile: null,
                    landline: null,
                },
                country: country,
                provinces: [],
                cities: [],
                civil_status: [],
                suffixes: [],
                gender: [],

                user: {},
                borrower: {},
                mother: {
                    fname: null,
                    mname: null,
                    lname: null,
                    suffix_code: null,
                },
                spouse: {
                    fname: null,
                    mname: null,
                    lname: null,
                    suffix_code: null,
                    date_birth: null
                },
                cb1: false,
                cb2: false
            }
        },

        validations() {
            const married = this.form.cs_code === 'CS002';
            const cb1 = this.cb1;
            const cb2 = this.cb2;
            const ph = this.form.country_iso === 'PH';
            return {
                spouse: {
                    fname: {
                        required: requiredIf(() => married)
                    },
                    lname: {
                        required: requiredIf(() => married)
                    },
                    mname: {
                        required: requiredIf(() => married && !cb2)
                    },
                    date_birth: {
                        required: requiredIf(() => married)
                    },
                },
                mother: {
                    fname: {
                        required
                    },
                    lname: {
                        required
                    },
                    mname: {
                        required: requiredIf(() => !cb1)
                    },
                },
                form: {
                    gender_id: {
                        required
                    },
                    cs_code: {
                        required
                    },
                    province_code: {
                        // required
                        required: requiredIf(() => ph)
                    },
                    city_code: {
                        // required
                        required: requiredIf(() => ph)
                    },
                    number_child: {
                        required
                    },
                    number_fam: {
                        required
                    },
                    country_iso: {
                        required
                    },
                },
                mobile_number: {
                    required,
                    minLength: minLength(14)
                }
            }
        },

        created() {
            this.getStep1();
            this.getProvince();
            this.getRefSuffix();
            this.getRefGender();
            this.getRefCivilStatus();
        },
        methods: {
            pasteMobile() {
                setTimeout(() => {
                    this.mobile_number = this.$refs["mob"].value;
                }, 300);
            },
            submitMobile() {
                this.errors = [];
                this.error_message = '';
                this.error = false;
                this.$v.mobile_number.$touch();
                if (this.$v.mobile_number.$invalid) {
                    this.error_message = "Please complete all required fields";
                    this.error = true;
                } else {
                    Fire.$emit('loader', 1)
                    axios
                        .post("/api/sblaf-add-mobile", {
                            mobile_number: this.mobile_number
                        })
                        .then(res => {
                            Fire.$emit('loader', -1)
                            $('#modalMobile').modal('hide');
                            this.getStep1();
                        }).catch(err => {
                            this.errors = err.response.data.errors || [];
                            this.error_message = err.response.data.message;
                            this.error = true;
                            Fire.$emit('loader', -1)
                        });
                }
            },

            btnNext() {
                this.$v.form.$touch();
                this.$v.mother.$touch();
                this.$v.spouse.$touch();
                if (this.$v.form.$invalid || this.$v.mother.$invalid || this.$v.spouse.$invalid) {
                    const err = {
                        response: {
                            data: {
                                message: "Please complete all required fields",
                            }
                        }
                    };
                    this.$emit('error', err);
                } else {
                    this.postStep1();
                }
            },
            toggleCheckbox(val, obj) {
                if (val) {
                    obj['mname'] = null;
                }
            },
            selectedCS(val) {
                if (val != 'CS002') {
                    this.spouse = {
                        fname: null,
                        mname: null,
                        lname: null,
                        suffix_code: null,
                        date_birth: null
                    }
                }
            },
            selectedCountry(val) {
                if (val != 'PH') {
                    this.form.city_code = null;
                    this.form.province_code = null;
                    this.cities = [];
                }
            },
            postStep1() {
                Fire.$emit('loader', 1)
                const payload = {
                    borrower: this.form,
                    mother: this.mother,
                    spouse: this.spouse
                };

                axios
                    .post("/api/sblaf-prereg-post-step1", payload)
                    .then(res => {
                        Fire.$emit('loader', -1)
                        this.$emit('next', 2);
                    })
                    .catch(err => {
                        Fire.$emit('loader', -1)
                        this.$emit('error', err);
                    });
            },
            getStep1() {
                Fire.$emit('loader', 1)
                axios
                    .get("/api/sblaf-prereg-step1")
                    .then(res => {
                        Fire.$emit('loader', -1)
                        let data = res.data
                        const bor = data.borrower;

                        this.borrower = bor;
                        this.user = data.user;
                        this.form.mobile = data.mobile || this.user.mobile_number;
                        this.form.landline = data.landline;

                        if (bor && bor.borrower_id) {
                            Object.assign(this.form, {
                                borrower_id: bor.borrower_id,
                                gender_id: bor.gender_id,
                                cs_code: bor.cs_code,
                                province_code: bor.province_code,
                                city_code: bor.city_code,
                                number_child: bor.number_child,
                                number_fam: bor.number_fam,
                                country_iso: bor.country_iso
                            });

                            if (bor.province_code) {
                                this.getCity(bor.province_code)
                            }
                        }
                        if (data.mother) {
                            this.mother = data.mother
                        }
                        if (data.spouse) {
                            this.spouse = data.spouse
                            this.spouse.date_birth = this.spouse.date_birth ? moment(this.spouse.date_birth).format('YYYY-MM-DD') : '';
                        }
                        if (!this.user.mobile_number) {
                            $('#modalMobile').modal('show');
                        }
                    })
                    .catch(err => {
                        console.log(err)
                        Fire.$emit('loader', -1)
                        this.$emit('error', err);
                    });
            },
            getRefSuffix() {
                Fire.$emit('loader', 1)
                axios
                    .get("/api/ref-suffix")
                    .then(res => {
                        Fire.$emit('loader', -1)
                        this.suffixes = res.data
                    })
                    .catch(err => {
                        Fire.$emit('loader', -1)
                        this.$emit('error', err);
                    });
            },
            getRefGender() {
                Fire.$emit('loader', 1)
                axios
                    .get("/api/ref-gender")
                    .then(res => {
                        Fire.$emit('loader', -1)
                        this.gender = res.data
                    })
                    .catch(err => {
                        Fire.$emit('loader', -1)
                        this.$emit('error', err);
                    });
            },
            getRefCivilStatus() {
                Fire.$emit('loader', 1)
                axios
                    .get("/api/ref-civil-status")
                    .then(res => {
                        Fire.$emit('loader', -1)
                        this.civil_status = res.data
                    })
                    .catch(err => {
                        Fire.$emit('loader', -1)
                        this.$emit('error', err);
                    });
            },
            getProvince() {
                Fire.$emit('loader', 1)
                axios
                    .get("/api/ref-province")
                    .then(res => {
                        Fire.$emit('loader', -1)
                        this.provinces = res.data
                    })
                    .catch(err => {
                        Fire.$emit('loader', -1)
                        this.$emit('error', err);
                    });
            },
            getCity(province_code) {
                Fire.$emit('loader', 1)
                axios
                    .get("/api/ref-city", {
                        params: {
                            province_code: province_code
                        }
                    })
                    .then(res => {
                        Fire.$emit('loader', -1)
                        this.cities = res.data
                    })
                    .catch(err => {
                        Fire.$emit('loader', -1)
                        this.$emit('error', err);
                    });
            },
        },
    }
</script>